import { useCallback, useMemo } from 'react'

import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import SectionRenderer from '@src/SectionRenderer'

import { SubCollection } from '../../domains/Collection'
import { getEnrichedCustomSection, shouldEnrichCustomSection } from '../../utils'

interface ICustomCollectionPageSection {
  filteredSubCollection: CustomSection | SubCollection
  filteredSubCollections: (CustomSection | SubCollection)[]
  isMounted: boolean
  slug: string
}

export const CustomCollectionPageSection: React.FC<ICustomCollectionPageSection> = ({
  filteredSubCollection,
  isMounted,
  filteredSubCollections,
  slug,
}) => {
  const customContainerRenderer = useCallback(
    (customSection: CustomSection) =>
      SectionRenderer({
        tracker: `collection_page__${slug}`,
      })(customSection),
    [slug],
  )

  const memoisedCustomEnrichedSection = useMemo(
    () =>
      customContainerRenderer(getEnrichedCustomSection(filteredSubCollection as CustomSection, filteredSubCollections)),
    [customContainerRenderer, filteredSubCollection, filteredSubCollections],
  )

  const memoisedCustomSection = useMemo(
    () => customContainerRenderer(filteredSubCollection as CustomSection),
    [customContainerRenderer, filteredSubCollection],
  )

  if (filteredSubCollection.typename !== 'CustomSection') return <></>
  if (shouldEnrichCustomSection(filteredSubCollection) && isMounted) {
    return memoisedCustomEnrichedSection
  }
  return memoisedCustomSection
}
